module.exports = __webpack_public_path__ + "media/payments/no-package-5b91765f.svg";